module.exports = __webpack_public_path__ + "img/LB.8edf7926.svg";